export default __webpack_public_path__ + "static/media/users.7ef45a68.svg";